const { createMachine } = require("xstate");
const actions = require("./actions");
const guards = require("./guards");
const services = require("./services");

const EditFiveWhysMachine = createMachine(
  {
    /** @xstate-layout N4IgpgJg5mDOIC5SQJYBcC0AzFA3MGA7gBYCesAdChADZgDEAygCoCCASswNoAMAuolAAHAPax0KEQDtBIAB6IATAGYKAVkUB2AJwAWZT2WaAjLsVrtAGhClEGABwqKANmd7ta3c57bF95wC+AdaomDj4RGSUAIYAxmh4YBQQYDhSYAAEQgBOIgBGdAC29AByAKIAGtz8sqLiCdKyCgjGqoqKumo8ZjyaGprd9ta2CBjKvhTKis5+rR26xvZBIRDo2ImR5BRxCfjJqSjpWbkFYMUACuwA8gBCADJlALIA+gDCABKsJQDiZQAivAESBAdQkjWBzQwKnsk2U42cum0hh4il8Qxsdk6PAo2m8Wi8yjUamcxmW4FWYQ2JC2O0S+zSmRy+SK9FYNy+fyuJWe7DKAEUAKplFj-QG1MRgmQQxDGHj2NQ4okDYzaTSuXTDOyeXQURTGVqq+yaRyaTRk0LrCLUmLxOnUjLGeiXMoANQAklcBYwxcDQQ0paBmn4dR57Cr7CbtPLDJrRso3JNEQN5bpDOYzcFyWtwgRrdtbXt7cYKFIRGgMmlojRWSVGAB1MrsN6fH6imq+iX+pp2FUKtwEhauWYajEIHXTeXOCwRkmEwzmimW3NRfO7JJFktliuHKulSrVIHCTuSAPyRBmdR6owLHjGCxqu+x9qKXWtO8I2XGczTBfZqkr2lCzIDJFCdXl3U9b12yPeoT27OMFgoOVcRmO98RVJ81GLbRlAWMM+h4Ic1F-SkrQAgt12Al9S3LStq0eDgAGlnlYRhngAMTdEpWDuH0YMleC5goUxbzUTQ8M8Ax0RGLpnAoHQxIMRT7B4HwSKXTYbTXCh7Worc6JretG2bL5fgBaCQWPcFAx7Vx1H1ex43jXEBnaWMSU0SZHG6Aw5SNKN1JzTTVztKjN1ondq3KKo+Ms2DrLPMdsVTQlFEI417E6DQRxGeVi30FS-DVXDtG0QL-xpCidLCgyBRKBj2GY1iOK4njYr9ODpRaPx1E8NLcIjQqOnc2V5KMNLZR8MSLHKsjKu03SKAM14uU49hHnaqzT2aKcFR8ewPDStxPGJWNMrk5RWlTLpNC0YxTVm5d5tC0gQKWyL6CuZh3mM84rkYRg3XuMo3lYL1hRM1tzMPOKBK63REOhZQVKRVNdtjCwXy0FRemcNVHPGR7gsAyjXpfWJiDAWIAGt6E2+LtsQZGYVVLRnDhNGvFjfQXy-eMSUcVoDFaIm8xJ6qyYoCmqdprhjBhjqEshYw5MIqY-N7O7dGk88NAoNHnHlNR-DDPVAkzC0grFqr7WUMDXQ9L16bhmyEOLZDDccYkwyws7xnkiwVbVPoDrhUXyIW4DVBo7cpF3BqmrYzjuN4izFcZlp9Hkjp4zUQkujwzRYy-OVhN0HQ5SJa6HotxcrYjl6Mmj-SPq+Iymw+Uy2wVrb4IwO8dXEnRbpcvwZiL0cvxUryh0N9njTVcPnqA17m4iuOov3Z2uy6rR1FcA7ZX8XFZTUYusLkgYvDz1wkX8XQl60xvVFq+qmJYpPWtTnuGcE1NJkWJ+doslboTxGHMF899xheF6NrW6j8Qorybu9De9AVolDWhtNOvcuq7SQlGQ6hEPCdGcOfFW8lugDCnB0PUWgEHi1tig3cX0fpNj+gDIGDxQbgzYp3KG29Oqu06KoVSz47wmFTKYYufhsSn3hOMA6jl6E2yjlLSmNM6bYN-vDVSOIoyXUMIbcS2sz6T1MDCL890tClQRn4ZRkdV5qJlnTeW4ptGuwVFMEwapbHGlSqY8B5jhJ6lATYswSxa5-jmk-JBuh7YQSdlol2iUxiIQ9qaFQnR-CkMnhfCh5dkTEjlCSexjcdQxwMgnD+LUU4CKVjKC8hJWi9D8gjXCyhi4V0mFGI0eo-LGmIpE0iT0YmkwyOUluqC24Ng7i2MydSM792JEhOc2hAGEQWAEmUEZZGdFNHjbwNjBkrCiSMxBYyJnr13NFA8bjknNARoqQqehMqXSmP4J8vRPLGhsfqW8cJTClNiUw6sdUqnNWTm1JJO9XYGhWftUwepMqOGLkibE7MrwHU6OXRQQKLkgrQatN060FnwSnMWBEXgSSogWHCHJ4CwyqCMESPUiwlI-iGRpa2DjxkEpYb9f6gNgbcMYBDPh8zoWCMSrhbEec7x5zSoibo5dPmmnkgdNFCMFJ0M5fXZe+LpYaNJV1cY2gXDfhRo5SlRpOmeCQplRE90xIiWUHiiWvLDWy1cR2dxKSFTG0pd4fUR9iQdMnn0HUcpsVTFaAMPobr7RqD3DFSV9SkpIVMK4IO6pejyifONAO-UOhUMNg-XVFVRnuqTdM4y4ru53JhSk98KyuhrLDBsx8o52i3RcBsvQTkeAnQTcBJNzoElQR-vcuwuF3YHVcEOLwiwdYIDSmqiug7TBKQ0MO16Sb+VsMFZwkGrwwait4XM+tPqp0IBleoS6GgNm3hTE+bGwl-CzGRgje+brYjZDANEBIUgoD0AgNIJIhxcAiGpkkX9-60AED1bAY1QiXzV3aJlFUOLhpdqjAqJEcIBiqQRKVDMJzhnEyqrBgDhxgNgGyLkbIFAhA0AA1gEQ2RChSz-QBhDFbkOJW1kyxEn7mWLvEk+JExZNDI0JP4Keec3WwAAK6xFiHAWAaC7j-TKPxyE3hPKojzn1PwaLFCxgMN4JColTbXUZW6ujDH6C8mYOwAAmrppQqoXAzFxMIi+hstk3sHWavQxtB1TCRYppThRCjRGyKQNBvJWDMB06mjOB1JgDExnOKcbh6VKBUgqQjG77ptvMFFmLcWEvgTdGUOsHm3b2txJOH5jl81IlhDMKa8ox6uvLdEqW0gcAcYyNEPI0QpCgakKydkJROQlAa8Gzy+gSTUpRIO1wsYHCXX1sjNw0wcLszvAg2IQ2UAjbGxNqbaCvivDKHcFis35sNYw0hYMqpXDKvE6ODAn2KCZWdWy42i68X0AFOcP4yWQY3DKBwYyzAriMTKAttLgkOs6EmipFUR1zN6jNdJlUMxCQ-K8EETMpYUjwGBJbCtDapV6aJLqDwhIzAmdEVt2UO2RO2KMCSQdCDqB0Dp2m2UZqiS+BUFMKYh2cp2D0JGkkZgVSmGkwp-rZySbC8WcjM1HsIzmENneYwW2LAXRmFoLCxsdBuDdSkBkxxmRnC1-BAY+DcK3WNrnLQy6MCtpWThDQjlMb3R3Q6Z3XUoRZ37OzQcMwwyy9GEu4SzO5MqD1GJUjWZyPcsbsWCpkVw+uzGP92cBEXKhowj9ya-3boEhUoYa6fWyNcobkgxQheUl6h1FhNl7M8uuTM6OAwg8R7iW6MbAmoe9JXJoB3naM9VIT9oXj43o4ND49uqiOlcqp8grn7rOSHk-AHUMARcwGNUTyU3zhXOl1d+ev3wgKMAdFhiXMKPQi5mJhTVZiiW+xjQ9lBH8oQUR5Jy5WZR530wEZRbwzV9BcZboDR2hzZm9ENzl3U15Y4qxH9Fgy5SpDE2VelpF7pe085vIjQskUCs8W99UMC98r1G0HlDYvJ9RA4R5T5iDPJvAyC0oKCZp1cKMeVVAH8GD6dEB-B8lj95QLN-Ji5ZRL4841QsI9BpNDZQ9dBgDFUW0fB1kPxAs7w1lJhcsdkUQ50y1UCK10D7RLksDZ9RCRc5IoCdA0VTdiQE9AEmU+gNAHIlIm9qC0CGFgIdQ6JH9HUcRxJuCSN5h7pi5GVMsWUfDwt1CnEaZH9xJ9ZHVicjQZh2YrBJ48YYRPY9sB5PxQ81BH8vNy4VYPBVI5Ru1l12gfB-t9BFCOZDFM8acBtxYqNAMoAKjkofApwphx4rUE8ipL4ZMcI40usqDOiNcqplNVN1NH8MsIxW1T5A5eg8iRgDAPB1AkQH12hQw-C5jBC6QHN2NH8+p-sIwEY0UPs9BzNgscQ9kegNtcRjl-DLDxZlNKt4sVjVZ0xTBiRXDB8RhsYzV2g4RURkw20Ti65LDTspBhtChRtxtJsEp05BJ9QmVQ4fBVcEY84ts-sAc3Bh5gTUQycAggA */
    predictableActionArguments: true,

    id: "edit-five-whys",

    context: {
      qmsToolApiUrl: undefined,
      authentication: {
        token: undefined,
      },
    },

    states: {
      idle: {
        on: {
          START: {
            target: "active",
            cond: "validCreateRequest",
            actions: [
              "saveReportId",
              "saveAuthentication",
              "saveInitialProblemStatement",
            ],
          },
        },
      },

      active: {
        states: {
          "define problem": {
            on: {
              NEXT: {
                target: "why 1.not final",
                cond: "validProblemStatement",
              },

              PROBLEM_CHANGED: {
                target: "define problem",
                internal: true,
                actions: "saveProblemStatement",
              },

              ABANDON_REQUESTED: "#edit-five-whys.confirm abandon",
            },
          },

          "why 1": {
            on: {
              PREVIOUS: "define problem",
            },

            states: {
              "not final": {
                on: {
                  ANSWER_CHANGED: {
                    target: "not final",
                    actions: "saveAnswer1",
                    internal: true,
                  },

                  NEXT: {
                    target: "#edit-five-whys.active.why 2.check",
                    cond: "validAnswer1",
                  },
                },
              },
            },

            initial: "not final",
          },

          "why 2": {
            on: {
              PREVIOUS: "why 1.not final",
            },

            states: {
              "not final": {
                on: {
                  MARK_AS_FINAL: {
                    target: "final",
                    cond: "validAnswer2",
                    actions: "saveAnswer2AsFinal",
                  },

                  ANSWER_CHANGED: {
                    target: "not final",
                    internal: true,
                    actions: "saveAnswer2",
                  },

                  NEXT: {
                    target: "#edit-five-whys.active.why 3.check",
                    cond: "validAnswer2",
                  },
                },
              },

              final: {
                on: {
                  UNMARK_AS_FINAL: {
                    target: "not final",
                    actions: "resetFinalAnswer",
                  },

                  CONFIRM: "#edit-five-whys.active.summary",

                  OTHER_POSSIBLE_CAUSES_CHANGED: {
                    target: "final",
                    internal: true,
                    actions: "saveOtherPossibleCauses",
                  },
                },
              },

              check: {
                always: [
                  {
                    target: "final",
                    cond: "answer2MarkedFinal",
                  },
                  "not final",
                ],
              },
            },

            initial: "check",
          },

          "why 3": {
            on: {
              PREVIOUS: "why 2.check",
            },

            states: {
              "not final": {
                on: {
                  MARK_AS_FINAL: {
                    target: "final",
                    cond: "validAnswer3",
                    actions: "saveAnswer3AsFinal",
                  },

                  ANSWER_CHANGED: {
                    target: "not final",
                    internal: true,
                    actions: "saveAnswer3",
                  },

                  NEXT: {
                    target: "#edit-five-whys.active.why 4.check",
                    cond: "validAnswer3",
                  },
                },
              },

              final: {
                on: {
                  UNMARK_AS_FINAL: {
                    target: "not final",
                    actions: "resetFinalAnswer",
                  },

                  CONFIRM: "#edit-five-whys.active.summary",

                  OTHER_POSSIBLE_CAUSES_CHANGED: {
                    target: "final",
                    internal: true,
                    actions: "saveOtherPossibleCauses",
                  },
                },
              },

              check: {
                always: [
                  {
                    target: "final",
                    cond: "answer3MarkedFinal",
                  },
                  "not final",
                ],
              },
            },

            initial: "check",
          },

          "why 4": {
            on: {
              PREVIOUS: "why 3.check",
            },

            states: {
              "not final": {
                on: {
                  MARK_AS_FINAL: {
                    target: "final",
                    cond: "validAnswer4",
                    actions: "saveAnswer4AsFinal",
                  },

                  ANSWER_CHANGED: {
                    target: "not final",
                    internal: true,
                    actions: "saveAnswer4",
                  },

                  NEXT: {
                    target: "#edit-five-whys.active.why 5",
                    cond: "validAnswer4",
                  },
                },
              },

              final: {
                on: {
                  UNMARK_AS_FINAL: {
                    target: "not final",
                    actions: "resetFinalAnswer",
                  },

                  CONFIRM: "#edit-five-whys.active.summary",

                  OTHER_POSSIBLE_CAUSES_CHANGED: {
                    target: "final",
                    internal: true,
                    actions: "saveOtherPossibleCauses",
                  },
                },
              },

              check: {
                always: [
                  {
                    target: "final",
                    cond: "answer4MarkedFinal",
                  },
                  "not final",
                ],
              },
            },

            initial: "check",
          },

          "why 5": {
            on: {
              NEXT: {
                target: "summary",
                cond: "validAnswer5",
                actions: "saveAnswer5AsFinal",
              },

              ANSWER_CHANGED: {
                target: "why 5",
                actions: "saveAnswer5",
                internal: true,
              },

              PREVIOUS: "why 4.check",

              OTHER_POSSIBLE_CAUSES_CHANGED: {
                target: "why 5",
                internal: true,
                actions: "saveOtherPossibleCauses",
              },
            },
          },

          creating: {
            invoke: {
              src: "createFiveWhys",
              id: "create-five-whys",
              onDone: {
                target: "success",
                actions: "resetChangeSet",
              },
              onError: {
                target: "error",
                actions: "saveError",
              },
            },
          },

          success: {
            on: {
              CLOSE: "#edit-five-whys.idle",
            },

            type: "final",
          },

          error: {
            on: {
              RETRY: "creating",
            },

            entry: "notifyError",
            type: "final",
          },

          summary: {
            on: {
              CREATE: "creating",
              REVIEW: "define problem",
            },
          },
        },

        initial: "define problem",

        on: {
          UPDATE_BEARER_TOKEN: {
            target: "active",
            internal: true,
            cond: "validToken",
            actions: "saveToken",
          },
        },
      },

      "confirm abandon": {
        on: {
          ABANDON: {
            target: "idle",
            actions: "resetChangeSet",
          },

          CANCEL_ABANDON: "active.define problem",
        },
      },
    },

    initial: "idle",
  },
  {
    actions: actions,
    guards: guards,
    services: services,
  },
);

export { EditFiveWhysMachine };
